export default (value, joiner) => {
  return value.join(joiner);
}
